<template>
  <div class="game-row-item">
    <el-select
      class="multiple-selector"
      placeholder="请选择游戏组"
      v-model="gameItem.gameGroupIds"
      multiple
      collapse-tags
      filterable
      clearable
      style="min-width: 220px"
      @change="onGameOrPlatformChange"
    >
      <el-option v-for="item in parentForm.appGroupsData" :key="item.groupId" :label="item.groupName" :value="item.groupId"> </el-option>
    </el-select>

    <slot>
      <el-select v-model="gameItem.platform" placeholder="请选择平台" style="min-width: 120px" @change="onGameOrPlatformChange(gameItem)">
        <el-option v-for="item in DailyReports.GAME_PLATFORM_LIST" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </slot>

    <slot name="start-date"></slot>
  </div>
</template>
<script>
/**
 * @description: 默认游戏组选择，适用平台投放、平台运营报表
 * @description: 选择游戏组、平台只能单选
 */
import DailyReports from '../data/daily.class.js'

export default {
  props: ['gameItem'],
  inject: ['parentForm'],

  computed: {
    DailyReports() {
      return DailyReports
    }
  },
  methods: {
    onGameOrPlatformChange() {
      this.$emit('change')
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles/game-row.scss';
</style>
